import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { UserRoleEnum } from './user-role-enum';

export const authGuard: CanActivateFn = () => {
  const _userService = inject(UserService);
  const _router = inject(Router);
  if (!_userService.userIsLoggedIn()) {
    console.warn('Not logged in - redrecting');
    _router.navigate(['/']);
  }
  return _userService.userHasRole(UserRoleEnum.UserAdmin);
};
